import 'slick-carousel'
import BLOCK_NEWS from '../modules/block-news'

const [ w, d, mq ] = [ window, document, window.matchMedia( "(max-width: 900px)" ) ]

const slider = {
  obj: '[data-plugin="slider"]',
  init() {
    $(this.obj).slick({
      autoplay: true,
      fade: false,
      dots: true,
      speed: 1200,
      autoplaySpeed: 4000,
      pauseOnHover: false,
      pauseOnFocus: false,
      centerMode: true,
      variableWidth: true,
      arrows: true,
      prevArrow: '<div class="prev"><i class="fa fa-angle-left"></i></div>',
      nextArrow: '<div class="next"><i class="fa fa-angle-right"></i></div>',
      responsive: [
        {
            breakpoint: 899,
            settings: {
              variableWidth: false
            }
        }
    ]
    })
  }
}

const init = () => {
  // slick実行
  window.load['mainvisual'].then(() => slider.init())

  // pickup
  $.when(
    $.getFreeBlock({id: 2, timestamp: '20201022'}),
    w.load['block-pickup']
  ).then( res => {
    let $content = $(`<div class="block-pickup__image">${res}</div>` )
    // デフォルトのご挨拶ブロックを削除
    $('.element.conceptelement','#main').parents('.block.block_head').remove()
    if( res != null && res != '' ) $('[data-plugin="pickup"]').empty().append( $content )
  })

}



export default function HOME() {
  BLOCK_NEWS()
  $(() => init())

}